<template>
  <div class="recovery-card" @click="$emit('check-type')">
    <h4>{{ title }}</h4>
    <p>{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    email: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.recovery-card {
  border-radius: $border-radius;
  border: 1.5px solid $gray-300;
  border-color: var(--gray-300);
  width: 100%;
  padding: 0.875rem 1.875rem 0.875rem 0.9rem;
  position: relative;
  margin-bottom: 0.625rem;
  &:hover {
    cursor: pointer;

    border-color: var(--secondary);
  }
  &:after {
    content: '';
    transform: rotate(-135deg);
    display: block;
    border: 1.5px solid transparent;
    border-right: 0;
    border-top: 0;

    border-color: var(--neutral-color-3);
    width: 0.425rem;
    height: 0.425rem;
    position: absolute;
    top: 1.875rem;
    right: 1.25rem;
  }
  h4 {
    color: var(--gray-700);
    font-size: 1rem;
    padding-bottom: 0.1875rem;
    margin-bottom: 0;
    font-weight: normal;
  }
  p {
    display: block;

    color: var(--gray-700);
    font-size: 0.875rem;
    font-weight: normal;
  }
}
</style>
